"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const monocle = require("monocle-ts");
const _metaschemaReducer = require("../../modules/metaschema/reducers");
const ActionTypes = require("../../actionTypes/subproject/schema");
const metaschemaReducer = _metaschemaReducer.default('subproject-schema');
//#endregion
//#region INITIAL STATE
exports.initialState = Object.assign(Object.assign({}, metaschemaReducer.initialState), { saveStatus: 'STANDBY' });
//#endregion
//#region LENS
const listLens = monocle.Lens.fromProp('list');
const saveStatusLens = monocle.Lens.fromProp('saveStatus');
//#endregion
//#region REDUCER
const methods = {};
exports.methods = methods;
Object.assign(methods, metaschemaReducer.methods);
methods[ActionTypes.FETCH_SCHEMA_REQUEST] = (state) => (Object.assign(Object.assign({}, state), { status: 'FETCHING', list: [] }));
methods[ActionTypes.ADD] = (state, action) => listLens.modify((items) => {
    const index = items.findIndex((x) => x.id === action.payload.id);
    const maxOrder = items.reduce((acc, item) => Math.max(acc, item.order), 0) + 1;
    if (index === -1) {
        return [...items, Object.assign(Object.assign({}, action.payload), { order: maxOrder })];
    }
    return items;
})(state);
methods[ActionTypes.MOVE] = (state, action) => listLens.modify((items) => {
    const clone = [...items];
    const index = clone.findIndex((x) => x.identifier === action.payload.item.identifier);
    if (index > -1) {
        const x = clone[index];
        const y = clone[index + action.payload.direction];
        if (x && y) {
            x.order += action.payload.direction;
            y.order -= action.payload.direction;
        }
    }
    clone.sort((a, b) => a.order - b.order);
    return clone;
})(state);
methods[ActionTypes.REMOVE] = (state, action) => listLens.modify((items) => {
    return items.filter((x) => x.id !== action.payload.id);
})(state);
methods[ActionTypes.SAVE_REQUEST] = (state, action) => saveStatusLens.set('FETCHING')(state);
methods[ActionTypes.SAVE_SUCCESS] = (state, action) => saveStatusLens.set('FETCHED')(state);
methods[ActionTypes.SAVE_FAILURE] = (state, action) => saveStatusLens.set('FAILED')(state);
methods[ActionTypes.CLEAR] = () => (Object.assign({}, exports.initialState));
//#endregion
//# sourceMappingURL=schema.js.map